<template>

  <div class="bg-breed-pink">

    <!-- bg_stars -->
    <div class="ui-bg-stars">
    </div>

    <!-- banner -->
    <div class="ui-uni-banner">
      <div class="container ref">
        <div class="title-box">
          <h1>
            {{lg('',{
              en: 'Breed',
              zh: '繁殖',
            })}}
          </h1>
          <div>
            {{lg('',{
              en: 'Make new lions',
              zh: '选择自己的如意伴侣，开始创造可爱的小狮子吧',
            })}}
          </div>
        </div>

        <img 
          class="banner-img" 
          src="/static/img/bg_uni_banner_02.png?v=2" 
          style="height: 200px; right:10px; bottom: -18px;"
        >
      </div>
    </div>

    <div class="sp-page container py-5">

      <div class="mb-3 bg-c">
        <div class="row py-1 px-3">

          <div class="col-2">
            <span
              class="cp text-white"
              @click="historyBack()"
              >
              <i class="fas fa-arrow-left"></i>
              {{lg('',{
                en: 'Back',
                zh: '',
              })}}
            </span>
          </div>
          <div class="col-8">
            <h4 class="text-center text-white mb-0">
              {{lg('',{
                en: 'Breeding',
                zh: '繁殖',
              })}}
            </h4>
          </div>
          <div class="col-2"></div>
        </div>
      </div>

      <!-- hide -->
      <div v-if="0" class="mt-4">
        <div class="row">
          <div class="col-5">
            <div 
              class="sp-btn-select strong-border cp w-100"
              :class="{'light-style': horse_female.tokenID === undefined}"
              @click="status_show_popup_female = true"
              >
              <div v-if="horse_female.tokenID === undefined">
                {{lg('',{
                  en: 'Select Female',
                  zh: '选择母狮子',
                })}}
              </div>

              <div v-else class="text-center">
                <div>
                  {{horse_female.horse_name}}
                </div>
                <div class="text-small">
                  <span class="op4">
                    {{lg('',{
                      en: 'You have selected',
                      zh: '已选择',
                    })}}
                  </span>
                  {{horse_female.horse_name}},
                  <span class="op4">
                    {{lg('',{
                      en: 'She is a beauty.',
                      zh: '她很漂亮',
                    })}}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-2 text-center op5">
            <i class="fas fa-heart mt-5 pt-3"></i>
          </div>

          <div class="col-5">

            <div 
              class="sp-btn-select w-100"
              >
              <div class="text-center">
                <div>
                  {{lg('',{
                    en: horse_stud.horse_name,
                    zh: '',
                  })}}
                </div>
                <div class="text-small op4">
                  {{lg('',{
                    en: horse_stud.horse_name + ' is Male and he is ready to mate.',
                    zh: horse_stud.horse_name + ' 公狮子，他正在等待她',
                  })}}
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <div class="sp-horse-box d-flex justify-content-center mt-5">

        <div 
          class="sp-lion-avatar"
          >
          <div class="sp-tip py-3">
            <div v-if="horse_female.tokenID === undefined">
              <h2>
                {{lg('',{
                  en: '?',
                  zh: '',
                })}}
              </h2>
              <div>
                {{lg('',{
                  en: 'Please select ',
                  zh: '请选择',
                })}}
                <br>
                {{lg('',{
                  en: 'a female lion',
                  zh: '一只母狮子',
                })}}
              </div>
            </div>

            <div v-else>
              <h2>
                {{horse_female.horse_name}}
              </h2>
              <div>
                <span>
                  {{lg('',{
                    en: 'You have selected',
                    zh: '你已选择',
                  })}}
                </span>
                <span>
                  {{horse_female.horse_name}},
                </span>
                <br>
                <span>
                  {{lg('',{
                    en: 'She is a beauty.',
                    zh: '她很漂亮',
                  })}}
                </span>
              </div>
            </div>
          </div>
          <div 
            @click="status_show_popup_female = true"
            :class="['cp lion-size-limit']">
            <picColored
              class="img-box"
              style="max-width: 300px; transform: rotateY(180deg); "
              :img="horse_female.image_url"
            />
          </div>
        </div>

        
        <div class="sp-lion-avatar">
          <div class="sp-tip py-3">
            <h2>
              {{horse_stud.horse_name}}
            </h2>
            <div>
              <b>{{horse_stud.horse_name}}</b>
              {{lg('',{
                en: 'is Male',
                zh: '公狮子',
              })}}
              <br>
              {{lg('',{
                en: 'and he is ready to mate.',
                zh: '正在等待他的她',
              })}}
            </div>
          </div>
          <div class=" lion-size-limit">
            <picColored
              class="img-box"
              style="max-width: 300px; transform: rotateY(180deg);"
              :img="horse_stud.image_url"
            />
          </div>
        </div>

      </div>

      <div class="sp-btn-box p-4 mt-5 text-center">

        <div v-if="!horse_female || horse_female.tokenID === undefined">
          {{lg('',{
            en: 'To proceed please select Female',
            zh: '如继续，请先选择母狮子',
          })}}
        </div>

        <div v-else>
          <div>
            <span class="b">
              {{horse_stud.horse_name}}
            </span>
            <span>
              {{lg('',{
                en: 'and',
                zh: '和',
              })}}
            </span>
            <span class="b">
              {{horse_female.horse_name}}
            </span>
            <span>
              {{lg('',{
                en: 'will create your very own offsprings. Once the birthing process is complete, you will be able to give your offspring its very own unique name.',
                zh: '将创造自己的后代。 繁殖过程完成后，你将能够为后代取一个独一无二的名字。 ',
              })}}
            </span>
          </div>
          <div class="mt-4 text-center">

            <div class="d-flex align-items-center justify-content-center">
              
              <input 
                class="form-control mx-2 form-control-lg text-center"
                type="text"
                readonly
                :value="`${(horse_stud.auctionInfo || {}).price} JGN`"
                style="width: 30%;"
              >

              <button 
                :disabled="(!horse_female.tokenID || !horse_stud.tokenID)"
                :class="['btn btn-lg mx-2', (!horse_female.tokenID || !horse_stud.tokenID) ? 'btn-outline-primary': 'btn-primary']"
                @click="action_bid()"
                style="width: 30%;"
                v-if="status_has_approve_bid"
                >
                {{lg('',{
                  en: 'Breed',
                  zh: '繁殖',
                })}}
              </button>

              <button 
                :class="['btn btn-lg mx-2', (!horse_female.tokenID || !horse_stud.tokenID) ? 'btn-outline-primary': 'btn-primary']"
                @click="action_approve_bid()"
                style="width: 30%;"
                v-if="!status_has_approve_bid"
                >
                {{lg('',{
                  en: 'Approve',
                  zh: '',
                })}}
              </button>
            </div>

          </div>
        </div>
      </div>

      <popupSelectMateB :cfg_show="status_show_popup_female" @close="status_show_popup_female = false"/>
    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'
import picColored from '@/views/_cp_base/pic_colored.vue'
import popupSelectMateB from '@/views/_cp_busi/popup_select_mate_b.vue'
// import blockPerformance from '@/views/_cp_busi/horse_item_block_performance.vue'

export default {
  name: '',
  components: {
    picColored,
    popupSelectMateB,
    // blockPerformance,
  },
  props: [],
  data() {
    return {
      status_show_popup_female: false,
      status_has_approve_bid: false,
      
      status_approving: false,
    }
  },
  computed: {
    address_my(){
      return this.$store.state.web3.account
    },
    horse_stud(){
     return this.$store.state.dataBus.data_on_select_mate || {}
    },
    horse_female(){
      return this.$store.state.dataBus.data_on_select_mate_female || {}
    },
  },
  watch: {},
  methods: {

    ...mapActions([
      'bid',
      'hasApproveBid',
      'approveBid',
      'getBidResult',
    ]),

    async action_bid(){



      let v = this
      
      if(v.form_horse_my && !v.form_horse_my.tokenID){
        return
      }

      try{

        v.$store.commit('setAppKey',{is_app_loading: 'bg-breed'})
        let res = await v.bid({
          horse_my: this.horse_female,
          horse_male: this.horse_stud,
        })
        v.$store.commit('setAppKey',{is_app_loading: false})
  
        if(res){
          v.$store.commit('setAppKey',{is_app_loading: 'bg-breed'})
          let obj = await v.getBidResult(v.address_my)
          v.$store.commit('setAppKey',{is_app_loading: false})
  
          v.$store.commit('setDataBusKey',{
            data_popup_show_new_born: obj,
          })
        }
      }
      catch{
        v.$store.commit('setAppKey',{is_app_loading: false})
      }
    },

    async action_approve_bid(){
      let v = this
      
      v.status_approving = true
      await v.approveBid({
        callback: function(){
          setTimeout(function(){
            v.status_has_approve_bid = true
            // v.$store.commit('setWeb3Data',{
            //   has_approve_bid: true,
            // })
            v.status_approving = false
          },2000)
        },
        callbackOnErr: function(){
          setTimeout(function(){
            v.status_approving = false
          },1000)
        },
      })
      
    },

    async checkApproveBid(){
      let v = this

      if(!v.$store.state.web3.account){return}

      let res = await v.hasApproveBid({
        address: v.$store.state.web3.account
      }) 

      v.status_has_approve_bid = res
      console.log('res bid approved:', res)
    },
    
    async init(){
      let v = this

      v.$store.commit('setDataBusKey',{
        data_on_select_mate_female: null,
      })

      setTimeout(() => {
        if(!v.$store.state.dataBus.data_on_select_mate){
          v.$router.replace({name: 'breeding'})
        }
      }, 2000);

      await v.checkApproveBid()
    },
  },
  created() {
    let v = this 

    v.init()
    

    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .sp-lion-avatar{
    margin: 20px ;
    background-color: mix($c2,#fff,35);
    border-radius: 20px;
    text-align: center;
    font-size: 16px;
    color: $c2;

    h2{
      font-size: 24px;
      color: #333;
    }

    .img-box{
      background-color: #fff;;
      border: 4px solid $c2;
      height: 100%;
      border-radius: 15px;
    }
  }

  .bg-breed-pink{
    background: url('/static/img/bg_bread_pink.jpg') center top;
  }

  .sp-page{

    .lion-size-limit{
      width: 300px;
      height: 300px;
      @media(max-width: 789px){
        width: 230px;
        height: 230px;
      }
    }

    .sp-btn-select{
      height: 80px;
      width: 100px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(120,120,120, 0.5);

      &.strong-border{
        border-color: rgba(120,120,120, 0.9);
        border-width: 2px;
      }
      
      &.light-style{
        border-color: $c;
        color: $c;
        border-width: 1px;
      }
    }

    .sp-horse-box{
      position: relative;
      font-size: 1.2em;
      z-index: 9;
      .sp-info-box{
        position: absolute;
        top: 80px;

        &>div{
          margin-bottom: 10px;

          &:nth-child(2){padding-left: 15px;}
          &:nth-child(3){padding-left: 30px;}
          &:nth-child(4){padding-left: 45px;}
          &:nth-child(5){padding-left: 60px;}
          &:nth-child(6){padding-left: 75px;}
        }
      }
    }

    .sp-btn-box{
      border: 1px solid  $c;
      background-color: mix($c2,#fff,35);
      border-radius: 15px;
    }

  }
</style>